var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeletePermission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-trash",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7l16 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11l0 6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11l0 6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletePermission);
export default __webpack_public_path__ + "static/media/delete_permission.a40f4cf51c327cf99157cf46986b91ad.svg";
export { ForwardRef as ReactComponent };